import { useState } from "react";
import { Input } from "@/components/ui/input.tsx";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectSeparator,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select.tsx";

const OTHER_KEY = "__other__";

interface SelectWithOtherProps {
  readonly options: readonly (
    | { readonly value: string; readonly label: string }
    | { readonly separator: true }
  )[];
  readonly value: string;
  readonly onValueChange: (value: string) => void;
  readonly placeholder?: string;
  readonly otherPlaceholder?: string;
}

export function SelectWithOther({
  options,
  value,
  onValueChange,
  placeholder,
  otherPlaceholder,
}: SelectWithOtherProps) {
  const isPreset = options.some((o) => "value" in o && o.value === value);
  const [custom, setCustom] = useState(!isPreset && value !== "");
  const [customText, setCustomText] = useState(custom ? value : "");

  const selectValue = custom ? OTHER_KEY : isPreset ? value : undefined;

  return (
    <div className="space-y-2">
      <Select
        value={selectValue}
        onValueChange={(key) => {
          if (key === OTHER_KEY) {
            setCustom(true);
            onValueChange(customText);
          } else {
            setCustom(false);
            onValueChange(key);
          }
        }}
      >
        <SelectTrigger>
          <SelectValue placeholder={placeholder ?? "Select…"} />
        </SelectTrigger>
        <SelectContent>
          {options.map((o, i) =>
            "separator" in o ? (
              <SelectSeparator key={`sep-${i}`} />
            ) : (
              <SelectItem key={o.value} value={o.value}>
                {o.label}
              </SelectItem>
            ),
          )}
          <SelectItem value={OTHER_KEY}>Other…</SelectItem>
        </SelectContent>
      </Select>
      {custom && (
        <Input
          placeholder={otherPlaceholder ?? "Please specify…"}
          value={customText}
          onChange={(e) => {
            setCustomText(e.target.value);
            onValueChange(e.target.value);
          }}
          autoFocus
        />
      )}
    </div>
  );
}
